/**
 *
 * ErrorHandler
 *
 */

import store from './store';
import { LOGOUT_USER_SUCCESS, UPDATE_ERROR_MESSAGE } from '../constants';

const ErrorHandler = (status) => {
  switch (status) {
    case 401:
      if (!store.state.isGetIsLogin) {
        store.commit(UPDATE_ERROR_MESSAGE, { code: 401, message: '您的登录已经过期, 请重新登录.' });
      } else {
        store.commit(LOGOUT_USER_SUCCESS);
      }
      break;
    case 403:
      if (!store.state.isGetIsLogin) {
        store.commit(UPDATE_ERROR_MESSAGE, {
          code: 403,
          message: '您的账号在别处登录，请确认是否是本人操作！',
        });
      } else {
        store.commit(LOGOUT_USER_SUCCESS);
      }
      break;
    case 404:
      store.commit(UPDATE_ERROR_MESSAGE, { code: 404, message: '您需要的资源没有找到.' });
      break;
    case 500:
      store.commit(UPDATE_ERROR_MESSAGE, { code: 500, message: '系统错误.' });
      break;

    case 503:
      store.commit(UPDATE_ERROR_MESSAGE, { code: 503, message: '服务暂时不可用.' });
      break;
    default:
      store.commit(UPDATE_ERROR_MESSAGE, {
        code: 500,
        message: '服务出错，请重试' /* '系统内部错误.' */,
      });
  }
};

export default ErrorHandler;
